var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/04 Menu/Reports") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/04-Menu/Reports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(4.000000, 4.000000)",
    stroke: "#373A37",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0004294,1.00000001 L11.999961,13 L22.955157,13 C22.7173828,15.638569 21.547878,18.0084711 19.7781746,19.7781746 C17.7875661,21.7687831 15.0375661,23 12,23 C8.96243388,23 6.21243388,21.7687831 4.22182541,19.7781746 C2.23121694,17.7875661 1,15.0375661 1,12 C1,8.96243388 2.23121694,6.21243388 4.22182541,4.22182541 C6.21252769,2.23112313 8.96269307,0.999883956 12.0004294,1.00000001 L12.0004294,1.00000001 Z",
    id: "Oval-4",
    fill: "#E1F3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0000763,1.74962422 C17.5781307,2.36593642 18.9788398,3.33634394 20.1049044,4.56279404 C21.2505943,5.81061898 22.1120604,7.32374296 22.586061,8.99957474 L22.586061,8.99957474 L16.0000093,8.99994394 Z",
    id: "Oval-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReports);
export default __webpack_public_path__ + "static/media/menu-reports.59152f8c0e4cfff480ce9772626c37b5.svg";
export { ForwardRef as ReactComponent };